var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useTheme } from '../../../theme';
import { COLOR, colors } from '../../../theme/colors';
import { getTypographyStyles } from '../../../theme/typography';
import { useMediaQuery } from '../../providers/media';
import { multiplyRemSize } from '../../../utils/misc';
import { useManualRerender } from '../../../utils/hooks/useManualRerender';
const ReadMoreLink = (props) => {
    const bg = colors[props.bg || COLOR.BACKGROUND];
    const color = colors[props.color || COLOR.ND_BLUE_LIGHT];
    return (_jsx("div", Object.assign({ css: {
            whiteSpace: 'nowrap',
            position: 'absolute',
            right: 0,
            bottom: 0,
            paddingLeft: '3rem',
            background: `linear-gradient(to right, ${bg}00, ${bg} 30%, ${bg} 100%)`,
        } }, { children: _jsx("div", Object.assign({ "aria-hidden": "true", sx: {
                color,
                transform: 'scale(0.9)',
                cursor: 'pointer',
            } }, { children: "Read More..." })) })));
};
export const useLinesHeight = (args) => {
    var _a, _b;
    const theme = useTheme();
    const styles = getTypographyStyles(args.typography);
    const fontSize = styles.fontSize;
    const fontSizeRem = ((_a = theme.fontSizes) === null || _a === void 0 ? void 0 : _a[fontSize]) || '1rem';
    const linesHeight = (((_b = theme.lineHeights) === null || _b === void 0 ? void 0 : _b[styles.lineHeight]) || 1.625) * args.lines;
    return multiplyRemSize({
        size: fontSizeRem,
        multiple: linesHeight,
    });
};
export const ReadMore = (_a) => {
    var _b, _c;
    var { typography, sx, role, lines, fixedHeight, children } = _a, rest = __rest(_a, ["typography", "sx", "role", "lines", "fixedHeight", "children"]);
    const ref = React.useRef(null);
    const [showEllipsis, setShowEllipsis] = useState(true);
    const forceRerender = useManualRerender();
    const wrapperHeight = useLinesHeight({ typography, lines });
    const { screenSize } = useMediaQuery();
    const { color: _color, bg: _bg } = sx || {};
    const color = Array.isArray(_color) ? _color[0] : _color;
    const bg = Array.isArray(_bg) ? _bg[0] : _bg;
    useEffect(() => {
        forceRerender({
            delay: [100, 500, 2000],
        });
    }, []);
    useEffect(() => {
        if (ref.current) {
            const isOverflowing = ref.current.scrollHeight > ref.current.clientHeight;
            if (isOverflowing) {
                setShowEllipsis(true);
            }
            else {
                setShowEllipsis(false);
            }
        }
    }, [
        children,
        wrapperHeight,
        screenSize,
        (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight,
        (_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.clientHeight,
    ]);
    return (_jsxs("div", Object.assign({ role: role || 'region', ref: ref, sx: Object.assign(Object.assign({ maxHeight: wrapperHeight, overflow: 'hidden', position: 'relative', height: fixedHeight ? wrapperHeight : 'auto' }, getTypographyStyles(typography)), sx) }, rest, { children: [children, showEllipsis && _jsx(ReadMoreLink, { bg: bg, color: color })] })));
};
